// extracted by css-extract-rspack-plugin
export default {"cls1":"SwpBulkFollowTakeover-cls1_IEX","cls2":"SwpBulkFollowTakeover-cls2_iOo SwpBulkFollowTakeover-cls1_IEX"};